import React, { Fragment } from 'react';
import { NavBar } from './../../Components/NavBar';
import { CenteredContainer } from './../../Components/CenteredContainer';
import { StaggeredAnimation } from './../../Components/StaggeredAnimation';
import { Timeline } from './../../Components/Timeline';
import { Popup } from './../../Components/Popup';
import { LazyP5Sketch } from '../../Backgrounds/LazyP5Sketch';
import { noiseWaveSketch } from '../../Backgrounds/noiseWaveSketch';
import moment from 'moment';
import pages from './../../Services/pages';
import './Styles/Work.css';

export class Work extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: [],
      checks: [
        "Master's degree in Computer Sciences (K.U. Leuven, 2005)",
        'Two years of experience in education as a programming lecturer',
        'Over a decade of experience throughout the entire software lifecycle on a variety of projects...',
        '...yet still eager to learn and improve my craft everyday',
        'Lover of clean code and solid architecture',
        'Currently, my main interests are JavaScript, generative art, TDD and functional programming concepts',
        'Fluent in English, French and Dutch'
      ],
      popupVisible: false,
      popupMessage: '',
      popupData: []
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.jobStore.getJobs().then(result => this.fillJobs(result));
    this.BG = LazyP5Sketch(noiseWaveSketch);
  }

  render() {
    return (
      <div>
        {this.BG}
        <NavBar pages={pages} active="work" />
        {this.state.popupVisible ? (
          <Popup
            message={this.state.popupMessage}
            onClose={this.closePopup}
            data={this.state.popupData}
          />
        ) : (
          <Fragment />
        )}
        <CenteredContainer ratio="90%" maxWidth="50em">
          <div className="Work">
            <div className="Title">
              <h1>
                <div className="Title__tldr">TL;DR</div>
                <span style={{ zIndex: 1 }}>I Like Stuff With</span>
                <div className="Title__computers">Computers</div>
              </h1>
            </div>
            <CenteredContainer ratio="100%" maxWidth="30em">
              <div className="Work__Checks">
                <StaggeredAnimation
                  items={this.state.checks}
                  renderItem={this.renderCheck}
                  startHidden={true}
                  animation="fadeInLeft"
                  duration={0.3}
                  incrementalDelay={0.05}
                />
              </div>
            </CenteredContainer>
            {/* <h3>
              <span style={{ zIndex: 1 }}>Work experience:</span>
            </h3> */}
            <Timeline items={this.state.jobs} renderItem={this.renderJob} />
          </div>
          <div className="Work__Download">
            <a
              href="./../docs/cv_david.pdf"
              download="CV_DavidVandenbogaerde.pdf"
            >
              Download as pdf
            </a>
          </div>
        </CenteredContainer>
      </div>
    );
  }

  renderJob = job => {
    return (
      <div className="Job">
        <div className="Job__Date">{this.getTimeText(job)}</div>
        <div className="Job__Title">{job.title}</div>
        <div className="Job__Employer">
          {job.employer}
          {this.getURLIcon(job)}
        </div>
        <div className="Job__Sector">
          {job.sector} - {job.location}
        </div>
        <div className="Job__Skills">
          <i className="fas fa-code" />
          {job.skills.join(', ')}
        </div>
        {job.highlights && job.highlights.length > 0 ? (
          <div className="Job__More">
            <i
              className="fas fa-plus-circle button"
              onClick={() => this.showJobDetails(job)}
            />
          </div>
        ) : (
          <Fragment />
        )}
      </div>
    );
  };

  renderCheck = check => {
    return (
      <React.Fragment>
        <i className="fas fa-check" />
        {check}
      </React.Fragment>
    );
  };

  renderSkill = skill => {
    return (
      <div className="skill" key={skill}>
        {skill}
      </div>
    );
  };

  fillJobs = result => {
    this.setState({ jobs: result });
  };

  getTimeText = job => {
    const start = moment(job.startDate).format('MMMM YYYY');
    let duration = 'current';
    if (job.endDate) {
      const dur = moment.duration(
        moment(job.endDate).diff(moment(job.startDate))
      );
      let y = dur.years();
      let m = dur.months();
      duration = this.getProperNoun(y, 'year', 'years');
      if (duration && this.getProperNoun(m, 'month', 'months')) {
        duration += ', ';
      }
      duration += this.getProperNoun(m, 'month', 'months');
    }
    return `${start}  -  (${duration})`;
  };

  getProperNoun = (count, sing, plur) => {
    if (count === 0) {
      return '';
    } else if (count === 1) {
      return count + ' ' + sing;
    }
    return count + ' ' + plur;
  };

  getURLIcon = job => {
    if (job.employerUrl) {
      return (
        <a href={job.employerUrl} target="_blank" rel="noopener noreferrer">
          <i className="fas fa-external-link-alt" />
        </a>
      );
    }
  };

  showJobDetails = job => {
    this.setState({
      popupVisible: true,
      popupMessage: job.title,
      popupData: job.highlights
    });
  };

  closePopup = () => {
    this.setState({ popupVisible: false, popupMessage: '', popupData: [] });
  };
}
